import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const item = css`
  display: grid;
  grid-template-columns: clamp(100px, 20%, 250px) 1fr;
`;

export const title = css`
  font-weight: 800;
`;

export const overview = css`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const details = css`
  color: ${theme.colors.peoople['gris-medio']};
`;
